/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class WorkflowExternalDefDtoModel extends JSONable {
  name: string | null = null;
  definitionFile: string | null = null;
  systemName: string | null = null;

  static createWorkflowExternalDefDtoModel(name: string | null, definitionFile: string | null, systemName: string | null) {
    const workflow = new WorkflowExternalDefDtoModel();
    workflow.name = name;
    workflow.definitionFile = definitionFile;
    workflow.systemName = systemName;
    return workflow;
  }
}
